<template>
  <div>
    <!-- Hero section Starts -->
    <section class="mx-6">
      <v-row>
        <v-col class="my-8"
          ><h1 style="font-size: 35px" class="hero-h1 mt-8">
            Empowering Your Digital Future with Innovative IT Solutions
          </h1>
          <p class="my-3" style="font-size: 20px">
            From stunning UI/UX design to seamless development, we deliver
            custom web solutions, including e-commerce, CMS, and digital
            marketing integration. Rely on us for maintenance, migrations, and
            innovative applications.
          </p>
          <v-btn class="mt-6" variant="flat" :to="{ name: 'about' }"
            >Know More</v-btn
          >
        </v-col>
        <v-col class="d-none d-md-block">
          <div>
            <v-img
              class="mx-auto"
              width="500"
              src="https://cdn.cosmicjs.com/656443b0-6a37-11ef-a492-5bdc7520fe60-v-logo.svg"
            ></v-img>
          </div>
        </v-col>
      </v-row>
    </section>
    <!-- Hero section Ends -->

    <!-- Hero Card Section Starts -->
    <div class="mb-10">
      <v-container>
        <v-row class="mb-2">
          <v-col cols="12" sm="6" md="3" class="d-flex justify-center">
            <v-card
              border
              rounded
              variant="flat"
              class="d-flex flex-column align-center justify-center text-center pa-4 hero-crd"
            >
              <v-icon color="#3982f0" class="h-crd-icon my-3" size="x-large"
                >mdi-briefcase</v-icon
              >
              <h3 class="h-crd-heading mb-3">Dedication</h3>
              <p class="h-crd-para mb-3">
                We're fully dedicated to understanding your needs and delivering
                custom IT solutions that help your business succeed in a
                competitive market.
              </p>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="d-flex justify-center">
            <v-card
              border
              rounded
              variant="flat"
              class="d-flex flex-column align-center justify-center text-center pa-4 hero-crd"
            >
              <v-icon color="#3982f0" class="h-crd-icon my-3" size="x-large"
                >mdi-lightbulb-on</v-icon
              >
              <h3 class="h-crd-heading mb-3">Innovation Driven</h3>
              <p class="h-crd-para mb-3">
                We leverage innovation to deliver IT solutions that keep your
                business ahead in a fast-changing digital world.
              </p>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="d-flex justify-center">
            <v-card
              border
              rounded
              variant="flat"
              class="d-flex flex-column align-center justify-center text-center pa-4 hero-crd"
            >
              <v-icon color="#3982f0" class="h-crd-icon my-3" size="x-large"
                >mdi-currency-inr</v-icon
              >
              <h3 class="h-crd-heading mb-3">Cost Efficiency</h3>
              <p class="h-crd-para mb-3">
                Maximize your investment with our cost-efficient IT solutions.
                We deliver high-quality results without breaking the bank.
              </p>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="d-flex justify-center">
            <v-card
              border
              rounded
              variant="flat"
              class="d-flex flex-column align-center justify-center text-center pa-4 hero-crd"
            >
              <v-icon color="#3982f0" class="h-crd-icon my-3" size="x-large"
                >mdi-emoticon-happy</v-icon
              >
              <h3 class="h-crd-heading mb-3">Client Satisfaction</h3>
              <p class="h-crd-para mb-3">
                Maximize your investment with our cost-efficient IT solutions.
                We deliver high-quality results without breaking the bank.
              </p>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- Hero Card Section Ends -->

    <!-- Service Section Starts -->
    <section class="mx-6">
      <div class="mb-10">
        <v-row class="mb-2" align="start" justify="center">
          <!-- Text Content Column -->
          <v-col cols="12" sm="12" md="6">
            <div>
              <h2>Transform Your Online Presence with Expert</h2>
              <h1 class="type-writing">
                <span class="typing-anim">{{ currentText }}</span>
              </h1>
              <p class="my-3 mb-4">
                Our website design team delivers top-notch services at
                competitive rates. Transform your online presence with our
                outstanding designs and propel your business forward.
                <br /><br />
                At Creators Web India, we began as a vibrant group of innovative
                website designers. Leveraging our skills and experience, we
                craft websites that help you connect with your target audience
                effectively. Whether you’re launching a new venture or growing
                an established business, we’re here to support your success!
              </p>
              <h3 class="position-relative mb-4">
                Our Top-Selling Services<span class="head-underline"></span>
              </h3>
              <div class="d-flex flex-wrap">
                <!-- First Column of Services -->
                <div class="mr-md-8 mb-md-4">
                  <ul class="custom-list">
                    <li>
                      <v-icon color="#3982f0" class="mr-2"
                        >mdi-arrow-right</v-icon
                      >UI/UX Design
                    </li>
                    <li>
                      <v-icon color="#3982f0" class="mr-2"
                        >mdi-arrow-right</v-icon
                      >Web Development
                    </li>
                    <li>
                      <v-icon color="#3982f0" class="mr-2"
                        >mdi-arrow-right</v-icon
                      >SEO and Digital Marketing
                    </li>
                    <li>
                      <v-icon color="#3982f0" class="mr-2"
                        >mdi-arrow-right</v-icon
                      >Content Management System
                    </li>
                  </ul>
                </div>
                <!-- Second Column of Services -->
                <div>
                  <ul class="custom-list">
                    <li>
                      <v-icon color="#3982f0" class="mr-2"
                        >mdi-arrow-right</v-icon
                      >E-Commerce Development
                    </li>
                    <li>
                      <v-icon color="#3982f0" class="mr-2"
                        >mdi-arrow-right</v-icon
                      >Website Maintenance and Support
                    </li>
                    <li>
                      <v-icon color="#3982f0" class="mr-2"
                        >mdi-arrow-right</v-icon
                      >Migration and Redesign Services
                    </li>
                    <li>
                      <v-icon color="#3982f0" class="mr-2"
                        >mdi-arrow-right</v-icon
                      >Graphic Designing
                    </li>
                  </ul>
                </div>
              </div>
              <v-btn variant="flat" class="mt-4 mt-md-0" @click="goToServices">
                View Services
              </v-btn>
            </div>
          </v-col>

          <!-- Image Content Column -->
          <v-col cols="12" sm="12" md="6" class="h-mob">
            <v-row>
              <!-- Image 1 -->
              <v-col cols="12" sm="6" md="4">
                <div class="position-relative">
                  <img
                    class="capsule-image"
                    :src="require('../assets/home-service-img.png')"
                  />
                  <v-icon class="position-absolute h-service-right-icon"
                    >mdi-star-circle-outline</v-icon
                  >
                </div>
              </v-col>
              <!-- Image 2 -->
              <v-col cols="12" sm="6" md="8">
                <div class="position-relative">
                  <img
                    class="capsule-image"
                    :src="require('../assets/home-service-img2.png')"
                  />
                  <!-- Icons Positioned on Top of Image -->
                  <v-icon class="position-absolute h-service-right-icon1"
                    >mdi-pencil-ruler</v-icon
                  >
                  <v-icon class="position-absolute h-service-right-icon2"
                    >mdi-code-tags</v-icon
                  >
                  <v-icon class="position-absolute h-service-right-icon3"
                    >mdi-store-outline</v-icon
                  >
                  <v-icon class="position-absolute h-service-right-icon4"
                    >mdi-microsoft-visual-studio-code</v-icon
                  >
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </section>
    <!-- Service Section Ends -->

    <!-- About Us Section Starts -->
    <section class="mx-6">
      <div class="mb-10">
        <div class="main-head mb-3">
          <span class="main-head-color"
            >About <span class="text-grey-darken-3">Us</span></span
          >
          <span class="main-head-outline">About Us</span>
        </div>
        <div>
          <v-row class="d-flex align-center">
            <v-col cols="12" sm="4" md="4">
              <div>
                <v-img :src="require('../assets/home-about-img.png')"></v-img>
                <v-icon></v-icon>
              </div>
            </v-col>
            <v-col class="ml-md-6"
              ><h2 class="hero-h1">
                Transforming Visions into Digital Success: Your Partner in Web
                and
                <br />
                IT Excellence
              </h2>
              <p class="my-5">
                We are a team of passionate freelancers specializing in web
                design, web development, SEO, and IT services. Our mission is to
                bring your digital vision to life, whether you’re launching a
                new website, enhancing your online presence, or streamlining
                your IT infrastructure. <br />

                With years of experience across various industries, we deliver
                custom solutions tailored to your unique needs. We blend
                cutting-edge technology with creative design to ensure your
                project not only looks great but performs flawlessly. From
                responsive websites to effective SEO strategies, we’re here to
                help you succeed online.<br />

                We value collaboration and transparency. We work closely with
                you at every step, ensuring your goals are met with precision
                and creativity. Let’s build something amazing together.
              </p>
              <v-btn
                class="hero-btn mt-3"
                variant="flat"
                :to="{ name: 'about' }"
                >Know More</v-btn
              ></v-col
            >
          </v-row>
        </div>
      </div>
    </section>
    <!-- About Us Section Ends -->

    <!-- Services Section Starts -->
    <section>
      <div>
        <div class="main-head">
          <span class="main-head-color"
            >Our <span class="text-grey-darken-3">Services</span></span
          >
          <span class="main-head-outline">Our Services</span>
        </div>
        <div class="carousel-container mb-10">
          <div class="carousel-content our-services-outline py-10">
            <h1 @click="goToServices" class="mx-8">
              <span class="home-service-circle"></span>UI/UX Design
            </h1>
            <h1 @click="goToServices" class="mx-8">
              <span class="home-service-circle"></span>Web Development
            </h1>
            <h1 @click="goToServices" class="mx-8">
              <span class="home-service-circle"></span>SEO and Digital Marketing
            </h1>
            <h1 @click="goToServices" class="mx-8">
              <span class="home-service-circle"></span>E-Commerce Development
            </h1>
            <h1 @click="goToServices" class="mx-8">
              <span class="home-service-circle"></span>Content Management System
            </h1>
            <h1 @click="goToServices" class="mx-8">
              <span class="home-service-circle"></span>Migration and Redesign
              Services
            </h1>
            <h1 @click="goToServices" class="mx-8">
              <span class="home-service-circle"></span>Website Maintenance and
              Support
            </h1>
            <h1 @click="goToServices" class="mx-8">
              <span class="home-service-circle"></span>Graphic Designing
            </h1>
          </div>
        </div>
      </div>
    </section>
    <!-- Services Section Ends -->
    <section>
      <div>
        <div
          class="home-footer-bg px-4 px-md-10 d-flex flex-column flex-md-row align-center justify-center justify-md-space-between"
        >
          <h1
            class="text-white text-center text-md-left pl-0 pl-md-8 mb-4 mb-md-0"
          >
            Let's talk about your <span class="footer-project">Project</span>
          </h1>
          <v-btn
            variant="flat"
            size="large"
            class="home-contact-btn mx-auto mx-md-0 mr-md-8"
            @click="goToContact"
          >
            Contact
          </v-btn>
        </div>
      </div>
    </section>
    <div app class="footer dark">
      <footer-view />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import footerView from "@/components/footerView.vue";
import { useRouter } from "vue-router";

const router = useRouter();

// The texts to display in the typing animation
const texts = [
  "UI/UX Design",
  "Web Development",
  "SEO & Digital Marketing",
  "E-Commerce Development",
  "Graphic Designing",
];

// Typing and erasing speed, and the pause duration between cycles
const typingSpeed = 50; // Speed of typing in ms
const erasingSpeed = 50; // Speed of erasing in ms
const pauseDuration = 1000; // Duration to pause before typing the next text

// Reactive variables to track current state
const currentText = ref("");
const textIndex = ref(0);
const charIndex = ref(0);
const isTyping = ref(true);

const goToServices = () => {
  router.push({ name: "services" });
};

const goToContact = () => {
  router.push({ name: "contact" });
};

// Typing animation function
const type = () => {
  if (isTyping.value) {
    if (charIndex.value < texts[textIndex.value].length) {
      currentText.value += texts[textIndex.value].charAt(charIndex.value);
      charIndex.value++;
      setTimeout(type, typingSpeed);
    } else {
      isTyping.value = false;
      setTimeout(type, pauseDuration);
    }
  } else {
    if (charIndex.value > 0) {
      currentText.value = currentText.value.slice(0, -1);
      charIndex.value--;
      setTimeout(type, erasingSpeed);
    } else {
      isTyping.value = true;
      textIndex.value = (textIndex.value + 1) % texts.length;
      setTimeout(type, pauseDuration);
    }
  }
};

// Start typing animation on component mount
onMounted(() => {
  type();
});
</script>
